import { render, staticRenderFns } from "./GroupBuyConfig.vue?vue&type=template&id=db7c542a&scoped=true"
import script from "./GroupBuyConfig.vue?vue&type=script&lang=js"
export * from "./GroupBuyConfig.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyConfig.vue?vue&type=style&index=0&id=db7c542a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7c542a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db7c542a')) {
      api.createRecord('db7c542a', component.options)
    } else {
      api.reload('db7c542a', component.options)
    }
    module.hot.accept("./GroupBuyConfig.vue?vue&type=template&id=db7c542a&scoped=true", function () {
      api.rerender('db7c542a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/groupBuy/GroupBuyConfig.vue"
export default component.exports